module.exports = __webpack_public_path__ + "static/media/quote-right.77b1b0e9.svg";